import { defineMessages } from 'react-intl';

type MessageKeys = 'rovoIsThinking' | 'agentIsThinking' | 'steps' | 'researchStepTitlePlaceholder';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		rovoIsThinking: {
			id: 'ai-mate.chat-history.message-research-refresh.rovo-is-thinking',
			defaultMessage: 'Rovo is thinking',
			description:
				'Status message text displayed in the chat history within the AI conversation interface when Rovo (the AI assistant) is processing a request and generating a response. Shown as text in a loading state indicator or message. The purpose is to inform users that the AI is actively working on their request and will respond shortly, providing feedback during the wait time.',
		},
		agentIsThinking: {
			id: 'ai-mate.chat-history.message-research-refresh.agent-is-thinking',
			defaultMessage: '{agentName} is thinking',
			description:
				'Status message text displayed in the chat history within the AI conversation interface when a specific AI agent is processing a request and generating a response. Shown as text in a loading state indicator or message. The agentName placeholder will be substituted with the name of the AI agent (e.g., "Project Manager Agent", "Code Assistant"). The purpose is to inform users that the specific agent is actively working on their request and will respond shortly.',
		},
		steps: {
			id: 'ai-mate.chat-history.message-research-refresh.steps',
			defaultMessage: 'Steps {count}/{count}',
			description:
				'Step indicator text displayed in the chat history within the AI conversation interface, showing the current step number and total number of steps in a multi-step process. Shown as text in a step indicator component. The count placeholder will be substituted with the step number (e.g., "Steps 2/5" means step 2 of 5 total steps). The purpose is to help users understand their progress through a multi-step research or processing operation.',
		},
		researchStepTitlePlaceholder: {
			id: 'ai-mate.chat-history.message-research-refresh.research-step-title-placeholder',
			defaultMessage: 'Searching for relevant information...',
			description:
				"Placeholder or default title text displayed for a research step in the chat history within the AI conversation interface when the step is in progress but doesn't have a specific title yet. Shown as text in a research step indicator. The purpose is to provide a default message indicating that the AI is actively searching for information while the specific step details are being determined.",
		},
	});

export default message;
